import { render, staticRenderFns } from "./PaymentGateways.vue?vue&type=template&id=20afc75a&scoped=true"
import script from "./PaymentGateways.vue?vue&type=script&lang=js"
export * from "./PaymentGateways.vue?vue&type=script&lang=js"
import style0 from "./PaymentGateways.vue?vue&type=style&index=0&id=20afc75a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20afc75a",
  null
  
)

export default component.exports